

























import Vue from 'vue'
import axios from 'axios'
import { mapGetters } from 'vuex'

export default Vue.extend({
  name: 'ContentsLink',

  props: ['file'],

  computed: {
    ...mapGetters(['contents', 'certificateInfo']),
    apiUrl() {
      return process.env.VUE_APP_API_URL
    }
  },

  data: () => ({
    error: false
  }),

  methods: {
    onDownload() {
      this.error = false
      const url = `${this.apiUrl}contents/${this.contents.code}/${this.file}`
      const params = this.certificateInfo
      axios({
        method: 'POST',
        url,
        data: params,
        responseType: 'blob'
      })
        .then((res) => {
          let blob = new Blob([res.data], { type: res.data.type })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = this.file
          link.click()
        })
        .catch((e) => {
          console.error(e)
          this.error = true
        })
    }
  }
})
